<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '420px': '330px'">
    <div
      class="dialog-container"
      :style="{padding:step==0?'':'15px'}">
      <template v-if="step == 0">
        <div class="plan-header">
          <div class="info flex">
            <h3>Mark As Issued</h3>
          </div>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :rules="rules"
            :model="formData">
            <div class="item-content">
              <div class="form-item">
                <span>Official Policy</span>
                <el-form-item
                  ref="pcy_pdf_path_id"
                  prop="pcy_pdf_path_id">
                  <v-upload
                    :card="true"
                    :fileData="formData.pcy_pdf"
                    :edit="true"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div
                class="form-item">
                <span>Policy No.</span>
                <el-form-item
                  ref="pcy_no"
                  prop="pcy_no">
                  <v-input v-model="formData.pcy_no" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Insured Period</span>
                <div>
                  <div class="flex flex-align">
                    <el-form-item
                      ref="ins_start_dt"
                      prop="ins_start_dt">
                      <v-date-picker
                        v-model="formData.ins_start_dt"
                      />
                    </el-form-item>
                    <span class="margin-time">To</span>
                    <el-form-item
                      ref="ins_end_dt"
                      prop="ins_end_dt">
                      <v-date-picker
                        v-model="formData.ins_end_dt"
                      />
                    </el-form-item>
                  </div>
                  <!--                  <span class="margin-time">To</span>-->
                  <!--                  <el-form-item-->
                  <!--                    ref="ins_end_dt"-->
                  <!--                    prop="ins_end_dt">-->
                  <!--                    <v-date-picker-->
                  <!--                      v-model="formData.ins_end_dt"-->
                  <!--                    />-->
                  <!--                  </el-form-item>-->
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <send-email-sms
          ref="send-email-sms"
          :initContent="issued_sms_content"
          :form="form"
          @cancel="handleSendCancel"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import SendEmailSms from '@/views/records/policy/components/dialog/send-email-sms'
import dayjs from 'dayjs'
import {mobileMakeIssued} from '@api/micropolicy'

export default {
  name: 'markAsIssuedDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      step: 0,
      extraBenefit:[],
      formData: {
        pcy_no: '',
        pcy_pdf: null,
        pcy_pdf_path: '',
        pcy_pdf_path_id: '',
        ins_start_dt: '',
        ins_end_dt: '',
        date: [],
        is_send:0,
        issued_sms_content:''
      },
      extraRules: {
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        date: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        pcy_pdf_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    issued_sms_content(){
      let {issued_sms_content} = this.form||{}
      let {pcy_no} = this.formData||{}
      let content = issued_sms_content.replaceAll('{:pcy_no}',pcy_no)
      return content
    },
    emailListTitle(){
      return this.form.enter_policy_url_list_title || ''
    },
    emailTitle(){
      return this.form.enter_policy_url_title || ''
    },
    sendForm(){
      let {product_id,customer} = this.form||{}
      return product_id==80?customer:this.form
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          const { pcy_no,ins_start_dt,ins_end_dt,pcy_cmnt_dt, pcy_expry_dt} = this.form
          const { file } = this.changeUploadData
          const {path,id} = file||{}
          this.formData.pcy_pdf = file
          this.formData.pcy_pdf_path_id = id
          this.formData.pcy_pdf_path = path
          this.formData.ins_start_dt = pcy_cmnt_dt
          this.formData.ins_end_dt = pcy_expry_dt
          if(ins_start_dt&&ins_end_dt)
            this.formData.date = [ins_start_dt,ins_end_dt]
          if(pcy_no) {
            this.formData.pcy_no = pcy_no
          }
        }
      }
    },
    'formData.ins_start_dt':{
      immediate:true,
      handler(val){
        let {plan_id} = this.form
        console.log(plan_id)
        if(plan_id>0&&val){
          let month = plan_id==1?12:24
          this.formData.ins_end_dt = dayjs(val).add(month,'month').subtract(1,'day').format('YYYY-MM-DD')

        }
      }
    },
  },
  methods: {
    handleSendCancel(){
      this.step = 0
    },
    handleCancel(){
      this.dialog = false
    },
    changeDialog() {
      this.step = 0
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result,otherData }) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData
      const {id = '', name = '', url = '', client_name = ''} = data

      this.$set(this.formData, 'pcy_pdf', data)
      this.$set(this.formData, 'pcy_pdf_path_id', data.id)
      this.$set(this.formData, 'pcy_pdf_path', data.path)
      this.$refs['form'].clearValidate(['pcy_pdf_path_id'])

    },
    handlerDeleteFile({otherData}) {
      const {type, idKey, nameKey, index = '', urlKey, target} = otherData

      this.$set(this.formData, 'pcy_pdf', null)
      this.$set(this.formData, 'pcy_pdf_path_id', '')
      this.$set(this.formData, 'pcy_pdf_path', '')
      this.$refs['form'].clearValidate(['pcy_pdf_path_id'])

    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          //   this.network().orderIssueIssuing()
          this.step = 1
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      //   this.$refs['send-form'].validate((valid, rules) => {
      //     if(valid) {
      this.formData.issued_sms_content = data.content
      this.formData.is_send = 1
      this.network().mobileMakeIssued()
      //     }
      //     else {
      //       console.log(rules)
      //     }
      //   })
    },
    onSkip() {
      this.formData.is_send = 0
      this.network().mobileMakeIssued()
    },
    network() {
      return {
        mobileMakeIssued: async (type) => {
          let params = {
            order_id: this.orderId,
            ...this.formData,
          }
          const { data } = await mobileMakeIssued(params)
          this.dialog = false
          this.$emit('success')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog{
  border-radius: 6px;
}
.dialog-container {
  .dialog-body{
    padding: 15px;
  }
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 1px solid #E1E4E8;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
  h3 {
    padding-bottom: 5px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    padding:0 15px 15px 15px;
    text-align: right;
    //background: #F9FAFB;
    display: flex;
    justify-content: space-between;
  }
  .form-item {
    & > span {
      //font-weight: bold;
      //font-size: 16px;
    }
  }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
}
</style>
